import { InputBase } from '../../../classes/input-base';
import { FeaturesStep4Form } from './features-step4-form';
import { InputText } from '../../../classes/input-text';

export class FeaturesStep4FormBargainBooksy extends FeaturesStep4Form {
	amazonLink = new InputText({
		key: 'amazonLink',
		label: 'Amazon Url',
		buttonSymbol: 'Go',
		required: true,
		blur: true,
	});

	kindleCountdownDeal = new InputBase({
		key: 'kindleCountdownDeal',
		label: 'Is this a Kindle Countdown Deal?',
		controlType: 'checkbox',
	});

	kindleUnlimited = new InputBase({
		key: 'kindleUnlimited',
		label: 'Is your book enrolled in Kindle Unlimited?',
		controlType: 'checkbox',
	});

	bookPriceDuringPromo = new InputText({
		key: 'bookPriceDuringPromo',
		label: 'Book Price During Promotion',
		required: true,
		type: 'number',
		addonSymbol: '$',
		min: 0,
	});
}
